export const WIZUALIZACJE = "/api/creations";
export const ZAKODOWANE = "/api/coded"